import React, { useState } from 'react';
import Papa from 'papaparse';
import { supabase } from "../lib/supabaseClient";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import QRCodeStyling from "qr-code-styling";

export default function BulkGenerator({ user, onBulkComplete }) {
  const [csvData, setCsvData] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => setCsvData(results.data),
      error: (err) => alert("CSV Error: " + err.message)
    });
  };

  const startBulkProcess = async () => {
    if (csvData.length === 0) return;
    
    setIsProcessing(true);
    setProgress(0);
    
    try {
      const zip = new JSZip();
      const total = csvData.length;

      for (let i = 0; i < csvData.length; i++) {
        const row = csvData[i];
        const escape = (str = "") =>
  str.replace(/([\\;,:"])/g, "\\$1");

const first = escape(row.FirstName || "");
const last = escape(row.LastName || "");
const fullName = `${first} ${last}`.trim();

const vcardData = `BEGIN:VCARD
VERSION:3.0
N:${last};${first};;;
FN:${fullName}
ORG:${escape(row.Company || "Digitoly")}
TEL;TYPE=CELL:${escape(row.Phone || "")}
EMAIL:${escape(row.Email || "")}
ADR:;;${escape(row.Address || "")};;;;
URL:${escape(row.Website || "")}
END:VCARD`;
      /*  const vcardData = `BEGIN:VCARD\nVERSION:3.0\nFN:${row.FirstName || ''} ${row.LastName || ''}\nORG:${row.Company || 'Digitoly'}\nTEL:${row.Phone || ''}\nEMAIL:${row.Email || ''}\nEND:VCARD`; */
        
        const shortCode = Math.random().toString(36).substring(2, 8);
        
        // FIX: Using a standard URL format so the dashboard dashboard includes it
        const fallbackUrl = `${window.location.origin}/card/${shortCode}`;

        const qrCode = new QRCodeStyling({
          width: 600, height: 600, data: vcardData,
          dotsOptions: { color: "#000000", type: "extra-rounded" },
          backgroundOptions: { color: "#ffffff" }
        });

        // Save to Database
        const blob = await qrCode.getRawData('png');

// Convert blob to base64 for storage
const base64 = await new Promise((resolve) => {
  const reader = new FileReader();
  reader.onloadend = () => resolve(reader.result);
  reader.readAsDataURL(blob);
});

const { error } = await supabase.from('qr_codes').insert([{
  user_id: user.id,
  name: `Bulk: ${row.FirstName || 'Entry'} ${row.LastName || i}`,
  code: shortCode,
  destination_url: fallbackUrl,
  qr_mode: 'vcard',
  is_dynamic: true,
  image_data: null,
  settings: {
    vcard: {
      firstName: row.FirstName || '',
      lastName: row.LastName || '',
      mobile: row.Phone || '',
      email: row.Email || '',
      address: row.Address || '',
      website: row.Website || '',
    }
  }
}]);

        if (error) console.error("Database Insert Fail:", error);

        zip.file(`${row.FirstName || 'User'}_${i}.png`, blob);
        
        setProgress(Math.round(((i + 1) / total) * 100));
      }

      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, `Digitoly_Batch_${Date.now()}.zip`);
      
      // Give Supabase a second to sync, then auto-navigate back
      setTimeout(() => {
        if (onBulkComplete) onBulkComplete();
      }, 1000);

    } catch (err) {
      alert("Error: " + err.message);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="bg-[#0f172a]/60 backdrop-blur-3xl border border-white/5 rounded-[48px] p-10 max-w-4xl mx-auto shadow-2xl">
      <div className="text-center mb-10">
        <h2 className="text-4xl font-black text-white italic uppercase tracking-tighter">Bulk Engine</h2>
        <p className="text-red-500 font-bold text-[10px] uppercase tracking-[6px] mt-2">vCard Mass Production</p>
      </div>

      <div className="border-2 border-dashed border-white/10 rounded-[32px] p-12 text-center bg-white/5 relative hover:border-red-500/50 transition-all cursor-pointer">
        <input type="file" accept=".csv" onChange={handleFileUpload} className="absolute inset-0 opacity-0 cursor-pointer" />
        <div className="text-4xl mb-2">📄</div>
        <p className="text-white font-bold text-sm uppercase tracking-widest">Upload CSV</p>
      </div>

      {csvData.length > 0 && (
        <div className="mt-10 flex justify-between items-center bg-white/5 p-6 rounded-2xl border border-white/5">
          <span className="text-white font-black text-[10px] uppercase tracking-[3px]">{csvData.length} Contacts Found</span>
          <button onClick={startBulkProcess} disabled={isProcessing} className="bg-red-600 hover:bg-red-500 text-white px-10 py-4 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all shadow-lg shadow-red-900/20">
            {isProcessing ? `Building... ${progress}%` : "⚡ Generate & Download"}
          </button>
        </div>
      )}
    </div>
  );
}